module.exports = __webpack_public_path__ + "static/media/work-img1.fd15332e.jpg";